<template>
  <div>
    <v-row class="px-3 requests-row">
      <v-col v-if="currentEmployee" cols="12" sm="6" md="4" class="request-col">
        <v-card class="request-card">
          <v-card-title><h5>Absence</h5></v-card-title>
          <v-divider></v-divider>
          <v-card-actions class="request-card-actions">
            <v-btn small text color="success" class="request-btn request-create-btn" @click="requestForAbsence = true">Create</v-btn>
            <v-btn small text color="secondary" class="request-btn request-history-btn" @click="openHistoryDialog('Absence')">History</v-btn>
            <v-btn small text color="primary" class="request-btn request-btn-policy" :href="linkAbsence.policyUrl || undefined" :disabled="!linkAbsence.policyUrl" target="_blank" rel="noopener">Policy</v-btn>
            <v-btn small text color="info" class="request-btn request-btn-instructions" :href="linkAbsence.instructionsUrl || undefined" :disabled="!linkAbsence.instructionsUrl" target="_blank" rel="noopener">How to apply</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col v-if="showBenefitCard" cols="12" sm="6" md="4" class="request-col">
        <v-card class="request-card">
          <v-card-title><h5>Benefit</h5></v-card-title>
          <v-divider></v-divider>
          <v-card-actions class="request-card-actions">
            <v-btn small text color="success" class="request-btn request-create-btn" @click="requestForExpenditureCompensation = true">Create</v-btn>
            <v-btn small text color="secondary" class="request-btn request-history-btn" @click="openHistoryDialog('Benefit')">History</v-btn>
            <v-btn small text color="primary" class="request-btn request-btn-policy" :href="linkBenefit.policyUrl || undefined" :disabled="!linkBenefit.policyUrl" target="_blank" rel="noopener">Policy</v-btn>
            <v-btn small text color="info" class="request-btn request-btn-instructions" :href="linkBenefit.instructionsUrl || undefined" :disabled="!linkBenefit.instructionsUrl" target="_blank" rel="noopener">How to apply</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <!-- <v-col v-if="currentEmployee" cols="12" md="auto">
        <v-card>
          <v-card-title><h5>Sport Compensation</h5></v-card-title>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn small color="primary" text @click="openHistoryDialog('Sport Compensation')">History</v-btn>
            <v-spacer class="mx-4"></v-spacer>
            <v-btn v-if="!isProductionEnv || checkIfOldRequestsStillWork" small color="success" @click="requestForSportCompensation = true">Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col v-if="currentEmployee" cols="12" md="auto">
        <v-card>
          <v-card-title><h5>Medical Insurance</h5></v-card-title>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn small color="primary" text @click="openHistoryDialog('Medical Insurance')">History</v-btn>
            <v-spacer class="mx-4"></v-spacer>
            <v-btn v-if="!isProductionEnv || checkIfOldRequestsStillWork" small color="success" @click="requestForMedicalInsurance = true">Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-col> -->
      <v-col v-if="currentEmployee" cols="12" sm="6" md="4" class="request-col">
        <v-card class="request-card">
          <v-card-title><h5>L&#38;D</h5></v-card-title>
          <v-divider></v-divider>
          <v-card-actions class="request-card-actions">
            <v-btn small text color="success" class="request-btn request-create-btn" @click="getAMList('requestForLAndD')">Create</v-btn>
            <v-btn small text color="secondary" class="request-btn request-history-btn" @click="openHistoryDialog('L&D')">History</v-btn>
            <v-btn small text color="primary" class="request-btn request-btn-policy" :href="linkLAndD.policyUrl || undefined" :disabled="!linkLAndD.policyUrl" target="_blank" rel="noopener">Policy</v-btn>
            <v-btn small text color="info" class="request-btn request-btn-instructions" :href="linkLAndD.instructionsUrl || undefined" :disabled="!linkLAndD.instructionsUrl" target="_blank" rel="noopener">How to apply</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col v-if="isInAmDepHeadList" cols="12" sm="6" md="4" class="request-col">
        <v-card class="request-card">
          <v-card-title><h5>Bonus</h5></v-card-title>
          <v-divider></v-divider>
          <v-card-actions class="request-card-actions">
            <v-btn small text color="success" class="request-btn request-create-btn" @click="requestForBonus = true">Create</v-btn>
            <v-btn small text color="secondary" class="request-btn request-history-btn" @click="openHistoryDialog('Bonus')">History</v-btn>
            <v-btn small text color="primary" class="request-btn request-btn-policy" :href="linkBonus.policyUrl || undefined" :disabled="!linkBonus.policyUrl" target="_blank" rel="noopener">Policy</v-btn>
            <v-btn small text color="info" class="request-btn request-btn-instructions" :href="linkBonus.instructionsUrl || undefined" :disabled="!linkBonus.instructionsUrl" target="_blank" rel="noopener">How to apply</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col v-if="isInAmDepHeadList" cols="12" sm="6" md="4" class="request-col">
        <v-card class="request-card">
          <v-card-title><h5>Raise</h5></v-card-title>
          <v-divider></v-divider>
          <v-card-actions class="request-card-actions">
            <v-btn small text color="success" class="request-btn request-create-btn" :disabled="true" @click="requestForRaise = true">Create</v-btn>
            <v-btn small text color="secondary" class="request-btn request-history-btn" @click="requestForRaiseHistory = true">History</v-btn>
            <v-btn small text color="primary" class="request-btn request-btn-policy" :href="linkRaise.policyUrl || undefined" :disabled="!linkRaise.policyUrl" target="_blank" rel="noopener">Policy</v-btn>
            <v-btn small text color="info" class="request-btn request-btn-instructions" :href="linkRaise.instructionsUrl || undefined" :disabled="!linkRaise.instructionsUrl" target="_blank" rel="noopener">How to apply</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col v-if="currentEmployee" cols="12" sm="6" md="4" class="request-col">
        <v-card class="request-card">
          <v-card-title><h5>Refund</h5></v-card-title>
          <v-divider></v-divider>
          <v-card-actions class="request-card-actions">
            <v-btn small text color="success" class="request-btn request-create-btn" @click="requestForRefund = true">Create</v-btn>
            <v-btn small text color="secondary" class="request-btn request-history-btn" @click="openHistoryDialog('Refund')">History</v-btn>
            <v-btn small text color="primary" class="request-btn request-btn-policy" :href="linkRefund.policyUrl || undefined" :disabled="!linkRefund.policyUrl" target="_blank" rel="noopener">Policy</v-btn>
            <v-btn small text color="info" class="request-btn request-btn-instructions" :href="linkRefund.instructionsUrl || undefined" :disabled="!linkRefund.instructionsUrl" target="_blank" rel="noopener">How to apply</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col v-if="currentEmployee" cols="12" sm="6" md="4" class="request-col">
        <v-card class="request-card">
          <v-card-title><h5>Equipment Replacement</h5></v-card-title>
          <v-divider></v-divider>
          <v-card-actions class="request-card-actions">
            <v-btn small text color="success" class="request-btn request-create-btn" @click="getAMList('requestForEquipmentReplacement')">Create</v-btn>
            <v-btn small text color="secondary" class="request-btn request-history-btn" @click="openHistoryDialog('Equipment Replacement')">History</v-btn>
            <v-btn small text color="primary" class="request-btn request-btn-policy" :href="linkEquipmentReplacement.policyUrl || undefined" :disabled="!linkEquipmentReplacement.policyUrl" target="_blank" rel="noopener">Policy</v-btn>
            <v-btn small text color="info" class="request-btn request-btn-instructions" :href="linkEquipmentReplacement.instructionsUrl || undefined" :disabled="!linkEquipmentReplacement.instructionsUrl" target="_blank" rel="noopener">How to apply</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <AbsenceRequest
      v-model="requestForAbsence"
      v-if="requestForAbsence"
    />
    <ExpenditureCompensationRequest
      v-if="requestForExpenditureCompensation"
      v-model="requestForExpenditureCompensation"
    />
    <SportCompensationRequest
      v-if="requestForSportCompensation"
      v-model="requestForSportCompensation"
    />
    <MedicalInsuranceRequest
      v-if="requestForMedicalInsurance"
      v-model="requestForMedicalInsurance"
    />
    <LAndDRequest
      v-model="requestForLAndD"
      v-if="requestForLAndD"
      :accountManagers="accountManagers"
    />
    <BonusRequest
      v-if="requestForBonus"
      v-model="requestForBonus"
    />
    <RaiseRequest
      v-if="requestForRaise"
      v-model="requestForRaise"
      :employee="employee"
    />
    <RaiseRequestHistory
      v-if="requestForRaiseHistory"
      v-model="requestForRaiseHistory"
      :employeeId="employee.Employee_ID"
    />
    <RefundRequest
      v-if="requestForRefund"
      v-model="requestForRefund"
    />
    <EquipmentReplacementRequest
      v-if="requestForEquipmentReplacement"
      v-model="requestForEquipmentReplacement"
      :accountManagers="accountManagers"
    />
    <v-dialog
      v-model="showRequestsHistoryMenu"
      max-width="90%"
      @click:outside="closeRequestHistoryDialog"
      @keydown.esc="closeRequestHistoryDialog"
    >
      <v-card>
        <v-card-title>
          {{ title }}
          <v-spacer></v-spacer>
          <v-btn
            @click="closeRequestHistoryDialog"
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-2">
          <AbsenceRequestHistory
            v-if="requestForAbsenceHistory"
            v-model="requestForAbsenceHistory"
          />
          <ExpenditureCompensationHistory
            v-if="expenditureCompensationRequestsHistory"
            v-model="expenditureCompensationRequestsHistory"
          />
          <SportCompensationRequestHistory
            v-if="requestForSportCompensationHistory"
            v-model="requestForSportCompensationHistory"
          />
          <MedicalInsuranceRequestHistory
            v-if="requestForMedicalInsuranceHistory"
            v-model="requestForMedicalInsuranceHistory"
          />
          <LAndDRequestHistory
            v-if="requestForLAndDHistory"
            v-model="requestForLAndDHistory"
          />
          <BonusRequestHistory
            v-if="requestForBonusHistory"
            v-model="requestForBonusHistory"
          />
          <RefundRequestHistory
            v-if="requestForRefundHistory"
            v-model="requestForRefundHistory"
          />
          <EquipmentReplacementRequestHistory
            v-if="requestForEquipmentReplacementHistory"
            v-model="requestForEquipmentReplacementHistory"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'EmployeeRequests',
  props: {
    employee: {
      required: false,
      default: null
    }
  },
  components: {
    AbsenceRequest: () => import('@/components/employee/employee_requests/AbsenceRequest'),
    AbsenceRequestHistory: () => import('@/components/employee/employee_requests/AbsenceRequestHistory'),
    SportCompensationRequest: () => import('@/components/employee/employee_requests/SportCompensationRequest'),
    SportCompensationRequestHistory: () => import('@/components/employee/employee_requests/SportCompensationRequestHistory'),
    MedicalInsuranceRequest: () => import('@/components/employee/employee_requests/MedicalInsuranceRequest'),
    MedicalInsuranceRequestHistory: () => import('@/components/employee/employee_requests/MedicalInsuranceRequestHistory'),
    LAndDRequest: () => import('@/components/employee/employee_requests/LAndDRequest'),
    LAndDRequestHistory: () => import('@/components/employee/employee_requests/LAndDRequestHistory'),
    BonusRequest: () => import('@/components/employee/employee_requests/BonusRequest'),
    BonusRequestHistory: () => import('@/components/employee/employee_requests/BonusRequestHistory'),
    RaiseRequest: () => import('@/components/employee/employee_requests/RaiseRequest'),
    RaiseRequestHistory: () => import('@/components/employee/employee_requests/RaiseRequestHistory'),
    ExpenditureCompensationRequest: () => import('@/components/employee/employee_requests/ExpenditureCompensationRequest'),
    ExpenditureCompensationHistory: () => import('@/components/employee/employee_requests/ExpenditureCompensationRequestHistory.vue'),
    RefundRequest: () => import('@/components/employee/employee_requests/RefundRequest'),
    RefundRequestHistory: () => import('@/components/employee/employee_requests/RefundRequestHistory'),
    EquipmentReplacementRequest: () => import('@/components/employee/employee_requests/EquipmentReplacementRequest'),
    EquipmentReplacementRequestHistory: () => import('@/components/employee/employee_requests/EquipmentReplacementRequestHistory')
  },
  data () {
    return {
      showRequestsHistoryMenu: false,
      title: null,
      today: moment().format('YYYY-MM-DD'),
      isProductionEnv: process.env.NODE_ENV === 'production',
      requestLinks: {
        Absence: { policyUrl: 'https://docs.google.com/document/d/1OJzYJ9VzkhbJoR1XV-tp9SbvIv6CYvCBtE40gA1QWtQ/edit?tab=t.0#heading=h.vrep3i7ijk92', instructionsUrl: 'https://docs.google.com/presentation/d/1JsTQGUmzYtDm5E_G8KoneinHJSb1bA_LpGhgFoK3iZY/present?slide=id.g2c010a0806b_1_6' },
        Benefit: { policyUrl: 'https://docs.google.com/document/d/1McxDKNL3wSRLP4A6WGEtEGObqzBIuKZUFSCstEK2mVY/edit?tab=t.0#heading=h.ihhslajl83ah', instructionsUrl: 'https://docs.google.com/presentation/d/1jMSDJhuM_KwKez4dIi7NXIEEOcapqUIhcgtc2sf-bqg/edit' },
        'L&D': { policyUrl: 'https://docs.google.com/document/d/1rMzZzpJJUtCtLrBls3vxqG-D-_YXNRRb34Eq_9khSw4/edit?tab=t.0#heading=h.u5nbbxfogdcz', instructionsUrl: 'https://docs.google.com/presentation/d/1facmulhBk6v4jOaqLyjChX2qeHRQJXSMlqPL1NXIzf8/present?slide=id.g2c02dc08337_0_0' },
        Bonus: { policyUrl: '', instructionsUrl: '' },
        Raise: { policyUrl: '', instructionsUrl: '' },
        Refund: { policyUrl: '', instructionsUrl: '' },
        EquipmentReplacement: { policyUrl: 'https://docs.google.com/document/d/1RLjH--UyCjT8T8lTUVVHJ6oyS7RZtPT5lH92kJTUER0/edit?tab=t.2eqmbqy3taxu#heading=h.dxsuicpp0tie', instructionsUrl: '' }
      },
      requestForAbsence: false,
      requestForAbsenceHistory: false,
      requestForSportCompensation: false,
      requestForSportCompensationHistory: false,
      requestForMedicalInsurance: false,
      requestForMedicalInsuranceHistory: false,
      requestForLAndD: false,
      requestForLAndDHistory: false,
      requestForBonus: false,
      requestForBonusHistory: false,
      requestForRaise: false,
      requestForRaiseHistory: false,
      requestForExpenditureCompensation: false,
      hasAccessOnExpenditureCompensation: false,
      expenditureCompensationRequestsHistory: false,
      amDepHeadListForAccess: [],
      requestForRefund: false,
      requestForRefundHistory: false,
      requestForEquipmentReplacement: false,
      requestForEquipmentReplacementHistory: false,
      accountManagers: []
    }
  },
  computed: {
    isInAmDepHeadList () {
      return this.amDepHeadListForAccess.some(e => e.Employee_ID === this.user.employee_id)
    },
    user () {
      return this.$store.getters.getUser
    },
    currentEmployee () {
      let res = false
      if (this.employee.Employee_ID && this.user.employee_id === this.employee.Employee_ID) {
        res = true
      }
      return res
    },
    checkIfOldRequestsStillWork () {
      const endDate = '2024-05-01'
      return moment(this.today).isBefore(moment(endDate))
    },
    showBenefitCard () {
      return this.currentEmployee && this.hasAccessOnExpenditureCompensation && (!this.isProductionEnv || !this.checkIfOldRequestsStillWork)
    },
    linkAbsence () {
      return this.requestLinks.Absence || {}
    },
    linkBenefit () {
      return this.requestLinks.Benefit || {}
    },
    linkLAndD () {
      return this.requestLinks['L&D'] || {}
    },
    linkBonus () {
      return this.requestLinks.Bonus || {}
    },
    linkRaise () {
      return this.requestLinks.Raise || {}
    },
    linkRefund () {
      return this.requestLinks.Refund || {}
    },
    linkEquipmentReplacement () {
      return this.requestLinks.EquipmentReplacement || {}
    }
  },
  mounted () {
    this.getAccessOnExpenditureCompensation()
    this.axios.get('/api/requests/list-of-am', {
      headers: { Authorization: 'Bearer ' + this.user.token }
    }).then(result => {
      this.amDepHeadListForAccess = result.data || []
    }).catch(() => {
      this.amDepHeadListForAccess = []
    })
  },
  methods: {
    closeRequestHistoryDialog () {
      this.showRequestsHistoryMenu = false
      this.requestForAbsenceHistory = false
      this.expenditureCompensationRequestsHistory = false
      this.requestForSportCompensationHistory = false
      this.requestForMedicalInsuranceHistory = false
      this.requestForLAndDHistory = false
      this.requestForBonusHistory = false
      this.requestForRefundHistory = false
      this.requestForEquipmentReplacementHistory = false
    },
    openHistoryDialog (history) {
      this.showRequestsHistoryMenu = true
      switch (history) {
        case 'Absence':
          this.title = 'Absence Requests History'
          this.requestForAbsenceHistory = true
          break
        case 'Benefit':
          this.title = 'Benefit Requests History'
          this.expenditureCompensationRequestsHistory = true
          break
        case 'Sport Compensation':
          this.title = 'Sport Compensation Requests History'
          this.requestForSportCompensationHistory = true
          break
        case 'Medical Insurance':
          this.title = 'Medical Insurance Requests History'
          this.requestForMedicalInsuranceHistory = true
          break
        case 'L&D':
          this.title = 'L&D Requests History'
          this.requestForLAndDHistory = true
          break
        case 'Bonus':
          this.title = 'Bonus Requests History'
          this.requestForBonusHistory = true
          break
        case 'Refund':
          this.title = 'Refund Requests History'
          this.requestForRefundHistory = true
          break
        case 'Equipment Replacement':
          this.title = 'Equipment Replacement Requests History'
          this.requestForEquipmentReplacementHistory = true
          break
      }
    },
    getAMList (popUp) {
      this[popUp] = true
      if (!this.accountManagers.length) {
        this.axios.get('/api/l_and_d_approvers', {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(result => {
          this.accountManagers = result.data
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      }
    },
    getAccessOnExpenditureCompensation () {
      this.axios.get(`/api/requests/has_access_expenditure_compensation/${this.user.employee_id}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.hasAccessOnExpenditureCompensation = res.data[0].Has_Access
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }
  }
}
</script>

<style scoped>
.request-col {
  min-width: 0;
}
.request-card {
  min-height: 120px;
  display: flex;
  flex-direction: column;
}
.request-card .v-card__title {
  flex: 0 0 auto;
}
.request-card .v-card__actions {
  flex: 1 1 auto;
  padding: 8px 16px;
  flex-wrap: wrap;
  gap: 4px 0;
}
.request-card-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.request-card-actions .request-btn {
  min-width: 0;
  margin: 0 2px;
  font-size: 0.875rem;
  text-transform: none;
  border: 1px solid transparent;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.6) !important;
}
.request-card-actions .request-btn:hover:not(.v-btn--disabled) {
  border-color: var(--v-primary-base);
  color: var(--v-primary-base) !important;
}
.request-card-actions .request-btn.v-btn--disabled {
  cursor: not-allowed;
  opacity: 0.45;
}
.theme--dark .request-card-actions .request-btn {
  color: rgba(255, 255, 255, 0.7) !important;
}
</style>
